import type { CreateChatThreadResponseAllOf } from './createChatThreadResponseAllOf';
import type { CreateChatThreadResponseAllOfFive } from './createChatThreadResponseAllOfFive';

export type CreateChatThreadResponse = CreateChatThreadResponseAllOf & CreateChatThreadResponseAllOfFive;
